<div class="project-title" [ngClass]="{ small: small == true }" [title]="projectNumber + ' ' + projectName">
    <h4>
        <span class="project-title__name">
            {{ projectNumber }}
            @if (projectName && projectName != projectNumber) {
            <span class="project-title__id">
                - {{ nameLength ? projectName.substring(0, nameLength) : projectName }}{{ nameLength && projectName.length > nameLength ? "..." : "" }}
            </span>
            }
        </span>
    </h4>
</div>
